export default __webpack_public_path__ + "static/media/crown.86fcea7d.svg";